import { BehaviorSubject } from 'rxjs';
import { Dispatch, SetStateAction } from 'react';

export type SpinnerStatusType = { pendingApiResponses: number; isIframeLoaded: boolean };
const initialState = { pendingApiResponses: 0, isIframeLoaded: true };

const state$ = new BehaviorSubject<SpinnerStatusType>(initialState);

const setState = (data: SpinnerStatusType) => {
  return state$.next(data);
};

const SpinnerService = {
  updateSpinnerStatus: (requestCount: number, isIframeLoaded: boolean) => {
    const pendingRequests = state$.value.pendingApiResponses + requestCount;
    setState({ pendingApiResponses: pendingRequests, isIframeLoaded: isIframeLoaded });
  },

  getSpinnerStatus: (setLoadingStatus: Dispatch<SetStateAction<SpinnerStatusType>>) => {
    return state$.asObservable().subscribe((next) => setLoadingStatus(next));
  },
};

export default SpinnerService;
